import React, { useEffect } from "react";

export const Problem: React.FC = () => {
  useEffect(() => {
    const problemSolverUrl = `${process.env.WAREHOUSE_PORTAL_SERVICE_URL}/problem-solver/issues?problemSolverContext=CROSSDOCK`;
    window.location.replace(problemSolverUrl);
  }, []);

  return null;
};
